import { createIcons, icons } from 'lucide';

const lucideOptions = {
    icons,
    'stroke-width': 1.5,
    nameAttr: 'data-lucide',
};

window.lucide = {
    createIcons: createIcons,
    icons: icons,
};

function initIcons() {
    createIcons(lucideOptions);
}

// Initial render — module scripts are deferred so DOM is ready when this runs
initIcons();

// Re-render after HTMX swaps in new content
document.addEventListener('htmx:afterSettle', initIcons);

// Re-render after Alpine.js finishes initialising (covers Alpine-rendered content)
document.addEventListener('alpine:initialized', initIcons);
